export const CORE_LOAD_MASTER_DATA_WAREHOUSES_REQUEST = "CORE_LOAD_MASTER_DATA_WAREHOUSES_REQUEST"
export const CORE_LOAD_MASTER_DATA_WAREHOUSES_SUCCESS = "CORE_LOAD_MASTER_DATA_WAREHOUSES_SUCCESS"
export const CORE_LOAD_MASTER_DATA_WAREHOUSES_FAILURE = "CORE_LOAD_MASTER_DATA_WAREHOUSES_FAILURE"

export const CORE_LOAD_MASTER_DATA_MATERIALS_REQUEST = "CORE_LOAD_MASTER_DATA_MATERIALS_REQUEST"
export const CORE_LOAD_MASTER_DATA_MATERIALS_SUCCESS = "CORE_LOAD_MASTER_DATA_MATERIALS_SUCCESS"
export const CORE_LOAD_MASTER_DATA_MATERIALS_FAILURE = "CORE_LOAD_MASTER_DATA_MATERIALS_FAILURE"


// WEBPACK FOOTER //
// ./src/app/redux/masterDataTypes.js